export type AnalyticsEvent = Record<string, unknown> & {
  event: string;
};

declare global {
  interface Window {
    dataLayer?: AnalyticsEvent[];
    _mtm?: AnalyticsEvent[];
    CCM: {
      consent: boolean;
      openControlPanel: () => void;
      openDetailsWindow(): () => void;
      acceptedEmbeddings: { id: string; name: string }[];
    };
  }
}

/**
 * Push event to Google Tag Manager
 * @param event
 */
const pushEventToGTM = (event: AnalyticsEvent) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
};

/**
 * Push event to Matomo Tag Manager
 * @param event
 */
const pushEventToMTM = (event: AnalyticsEvent) => {
  window._mtm = window._mtm || [];

  const updatedEvent = {
    ...event,
    event: `mtm_${event.event}`,
  };
  window._mtm.push(updatedEvent);
};

export const pushAnalyticsEvent = (event: AnalyticsEvent) => {
  const triggerTrackingEvents = () => {
    pushEventToGTM(event);
    pushEventToMTM(event);
  };
  const INTERVAL_TRACKING_TIME = 100;

  if (window && window.CCM?.consent) {
    const trackingInterval = setInterval(() => {
      const consentEvent =
        window.dataLayer &&
        window.dataLayer.find(
          (dataLayer) => dataLayer.event === 'CCM19.consentStateChanged'
        );

      if (consentEvent) {
        triggerTrackingEvents();
        clearInterval(trackingInterval);
      }
    }, INTERVAL_TRACKING_TIME);
  }
};
